import { render, staticRenderFns } from "./FooterElement.vue?vue&type=template&id=5e796c58&scoped=true"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"
import style0 from "./FooterElement.vue?vue&type=style&index=0&id=5e796c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e796c58",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InView: require('/home/node/app/components/ui/inView.vue').default,EditorTipTap: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorTipTap.js').default,ControllerFooter: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerFooter.js').default,UiInput: require('/home/node/app/components/ui/uiInput.vue').default,Plane: require('/home/node/app/assets/icons/plane.vue').default,ControllerNewsletter: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerNewsletter.js').default,EditorList: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorList.js').default})
